import React from 'react'
import { Button, Popover, Position, Tag } from '@blueprintjs/core';
import { observable, action } from 'mobx';
import { observer } from "mobx-react";
import ListPicker from 'components/ListPicker';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { priorityMapping } from 'helpers/priorityTag';

const selectAllId = "selectAll";

const OPTIONS = ['normal', 'medium', 'high', 'urgent', 'waiting_on_parts'].map((value) => {
    const { emoji, label, background, text } = priorityMapping(value);
    return { label: `${emoji} ${label}`, value, pill: { background, text } };
});

const pillStyle = (pill) => pill && { backgroundColor: pill.background, color: pill.text, fontWeight: 600 };

@observer
class PriorityTagPicker extends React.Component {

    @observable options = OPTIONS;
    @observable selectedOptions = [];

    componentDidMount() {
        if (this.props.selectedOptions) {
            this.selectedOptions = this.props.selectedOptions.map(val => {
                const option = _.find(OPTIONS, { value: val });
                return option ? { ...option, selected: true } : null;
            }).filter(Boolean);
        }
    }

    onChange = (selectedOptions) => {
        if (this.props.includeSelectAll) {
            if (selectedOptions.length > this.selectedOptions.length) {
                if (
                    selectedOptions.filter((option) => option.value === selectAllId)
                        .length > 0 ||
                    selectedOptions.length === this.options.length
                ) {
                    this.selectedOptions = this.options.map((option) => ({
                        ...option,
                        selected: true,
                    }));
                } else {
                    this.selectedOptions = selectedOptions;
                }
            } else {
                if (
                    selectedOptions.filter((option) => option.value === selectAllId)
                        .length === 0 &&
                    this.selectedOptions.filter((option) => option.value === selectAllId)
                        .length > 0
                ) {
                    this.selectedOptions = [];
                } else {
                    this.selectedOptions = selectedOptions.filter(
                        (option) => option.value !== selectAllId
                    );
                }
            }
        } else {
            this.selectedOptions = selectedOptions;
        }
        if (this.props.onChange) {
            this.props.onChange(this.selectedOptions, this.options);
        }
    }

    render() {
        let {
            onChange,
            props: {
                maximumSelections
            }
        } = this;

        const optionsWithSelectAll = this.props.includeSelectAll ? [
            { label: 'Select All', value: selectAllId, selected: this.selectedOptions.length === OPTIONS.length },
            ...OPTIONS.map(opt => ({ ...opt, selected: _.some(this.selectedOptions, { value: opt.value }) }))
        ] : OPTIONS.map(opt => ({ ...opt, selected: _.some(this.selectedOptions, { value: opt.value }) }));

        const content = <ListPicker
            selectedOptions={this.selectedOptions}
            options={optionsWithSelectAll}
            onChange={onChange}
            maximumSelections={maximumSelections}
        />

        let label = this.selectedOptions.length || 0;
        if (this.selectedOptions.length === 1 && this.selectedOptions[0].label) {
            label = this.selectedOptions[0].label;
        } else if (this.selectedOptions.length > 0 && this.selectedOptions.length === OPTIONS.length) {
            label = "All";
        }

        return (
            <Popover
                minimal={true}
                content={content}
                position={Position.BOTTOM_LEFT}
                usePortal={true}
                className="actionItem"
            >
                <Button rightIcon='caret-down'>
                    Priority
                    <span>&nbsp;</span>
                    <Tag minimal={true} round={true} style={this.selectedOptions.length === 1 ? pillStyle(this.selectedOptions[0].pill) : undefined}>{label}</Tag>
                </Button>
            </Popover>
        )
    }
}

PriorityTagPicker.propTypes = {
    selectedOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    maximumSelections: PropTypes.number,
    includeSelectAll: PropTypes.bool
}

export default PriorityTagPicker;
